import { Link } from 'react-router';
import { pure } from 'recompose';

export default pure(Link);



// WEBPACK FOOTER //
// ../src/client/components/Link.js